module.exports = __webpack_public_path__ + "static/media/logo-gor-black.d36e610c.png";